import React from 'react'

export default function ({setLoading}) {
  setLoading(false);
  return (
    <>
    sdfsdkfkj
    </>
  )
}
